import React from "react";
import TopCategories from "../components/TopCategories/TopCategories";


const TopCategoriesContainer = () => {
  return (
    <TopCategories />
  );
};

export default TopCategoriesContainer;
